<template>
  <div id="opportunity">
    <top></top>
    <div class="main">
      <!-- 左侧菜单 -->
      <navMenu :active="active"></navMenu>
      <!-- 右侧内容区域 -->
      <div class="content" v-loading="loading">
        <div class="content-main">
          <div class="main-title">
            {{ lang === "cn" ? "商机管理" : "Opportunity Management" }}
          </div>
          <div class="search-wrap">
            <div class="search-input">
              <el-input
                v-model="keywords"
                :placeholder="
                  lang === 'cn'
                    ? '请输入商机关键词'
                    : 'Please enter the business opportunity keywords'
                "
              ></el-input>
            </div>
            <div class="search-input search-btn-wrap">
              <div class="search-btn" @click="handleSearchKeywords">
                {{ lang === "cn" ? "搜索" : "Search" }}
              </div>
            </div>
          </div>
        </div>
        <p v-if="lang === 'cn'">
          共有 <span>{{ opportunityNumber }}</span> 个商机
        </p>
        <p v-if="lang === 'en'">
          There are a total of <span>{{ opportunityNumber }}</span> business
          opportunities
        </p>
        <div class="content-main">
          <el-table
            :data="tableData"
            style="width: 100%"
            :empty-text="lang === 'cn' ? '暂无数据' : 'No Records Found'"
          >
            <el-table-column prop="id" label="ID" min-width="60">
            </el-table-column>
            <el-table-column
              prop="business_opportunity"
              :label="lang === 'cn' ? '商机类别' : 'Type'"
              min-width="80"
            >
            </el-table-column>
            <el-table-column
              prop="product_image"
              :label="lang === 'cn' ? '用户头像' : 'User Avatar'"
              width="200"
            >
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.avatar_image"
                  :fit="'contain'"
                  :preview-src-list="[scope.row.avatar_image]"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              :label="lang === 'cn' ? '发布者昵称' : 'publisher name'"
              min-width="180"
            >
            </el-table-column>
            <el-table-column
              prop="company"
              :label="lang === 'cn' ? '单位名称' : 'company name'"
              min-width="200"
            >
            </el-table-column>
            <el-table-column
              :label="lang === 'cn' ? '产品标签' : 'product label'"
              min-width="120"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    lang === "cn"
                      ? scope.row.product_category
                      : scope.row.product_category_en
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="lang === 'cn' ? '需求描述' : 'requirement description'"
              width="300"
            >
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.requirement"
                  placement="top-start"
                >
                  <div class="demandDescription">
                    {{ scope.row.requirement }}
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              :label="lang === 'cn' ? '审核状态' : 'Audit Status'"
              min-width="80"
            >
              <template slot-scope="scope">
                <div :style="{ color: scope.row.textColor }">
                  {{ scope.row.audit_status }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="lang === 'cn' ? '操作' : 'operation'"
              min-width="260"
              fixed="right"
            >
              <template slot-scope="scope">
                <div class="buttonGroup">
                  <div
                    class="responseButton"
                    @click="toResponseList(scope.row)"
                  >
                    {{ lang === "cn" ? "应答内容" : "response content" }}
                  </div>
                  <div
                    class="responseButton"
                    @click="handleShowDialog(scope.row.id)"
                  >
                    {{ lang === "cn" ? "修改" : "modify" }}
                  </div>
                  <div
                    class="responseButton"
                    @click="handleDeleteBusinessOpportunity(scope.row)"
                  >
                    {{ lang === "cn" ? "删除" : "delete" }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination_box">
          <el-pagination
            background
            @current-change="handleCurrentPageChange"
            :current-page="pageNumber"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 1">
            <div class="btn" @click="next('skip')">
              {{ lang === "cn" ? "跳过" : "Skip" }}
            </div>
            <div class="btn next-btn" @click="next('known')">
              {{ lang === "cn" ? "下一步" : "Next Step" }}
            </div>
          </template>
          <!-- 可跳过无需验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 0">
            <!-- 24.9.1 已知悉改成下一步 dxm-->
            <!-- 24.10.15 zhang  不可配置 ljj 展商认证添加跳过按钮 -->
            <div class="btn" @click="next('skip')">
              {{ lang === "cn" ? "跳过" : "Skip" }}
            </div>
            <div class="btn next-btn" @click="next('known')">
              {{ lang === "cn" ? "下一步" : "Next Step" }}
            </div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template v-if="detail.is_skip == 0 && detail.is_verify == 1">
            <div class="btn next-btn" @click="next('known')">
              {{ lang === "cn" ? "下一步" : "Next Step" }}
            </div>
          </template>
        </div>
      </div>
    </div>
    <el-dialog
      :title="lang === 'cn' ? '修改商机' : 'Edit Business Opportunity'"
      @close="handleCloseDialog"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        :model="opportunityForm"
        :rules="opportunityRules"
        ref="opportunityRef"
        label-position="right"
        label-width="240px"
      >
        <el-form-item
          :label="
            lang === 'cn' ? '商机类别:' : 'Business Opportunity Category:'
          "
          prop="category"
        >
          <el-select
            v-model="opportunityForm.category"
            placeholder="请选择商机类别"
          >
            <el-option
              v-for="(item, index) in business_opportunity_options"
              :key="index"
              :label="lang == 'cn' ? item.name : item.name_en"
              :value="item.value + ''"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="lang === 'cn' ? '发布者昵称：' : 'Poster Nickname:'"
          prop="name"
        >
          <el-input
            disabled
            type="text"
            v-model="opportunityForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="lang === 'cn' ? '单位名称：' : 'Company Name:'"
          prop="company"
        >
          <el-input
            disabled
            type="text"
            v-model="opportunityForm.company"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="lang === 'cn' ? '商品标签：' : 'Product Tag:'"
          prop="product_category_id"
        >
          <el-select
            v-model="opportunityForm.product_category_id"
            placeholder="请选择商品标签"
            @change="handleProductCategoryChange"
          >
            <el-option
              v-for="(item, index) in productLabelList"
              :key="index"
              :label="lang == 'cn' ? item.category_name : item.en_category_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="lang === 'cn' ? '需求描述：' : 'Requirement Description:'"
          prop="requirement"
        >
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入需求描述"
            v-model="opportunityForm.requirement"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="lang === 'cn' ? '审核状态：' : 'Verification Status:'"
          prop="examine"
        >
          <el-select
            v-model="opportunityForm.examine"
            placeholder="请选择商机类别"
            disabled
          >
            <el-option
              v-for="(item, index) in audit_status_options"
              :key="index"
              :label="lang == 'cn' ? item.name : item.name_en"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="opportunityForm.category != 2"
          :label="lang === 'cn' ? '上传图片：' : 'Upload Image'"
          prop="imgs"
        >
          <div class="image-wrapper">
            <div
              class="image-box"
              v-for="(item, index) in opportunityForm.imgs"
              :key="index"
            >
              <el-image :src="item" :fit="'contain'"></el-image>
              <div class="image-mask">
                <i @click="deleteImageInForm(index)" class="el-icon-delete"></i>
              </div>
            </div>
            <div class="image-uploader">
              <i class="el-icon-plus"></i>
              <el-upload
                :before-upload="beformUploadImg"
                :on-success="uploadImgSuccess"
                :show-file-list="false"
                :action="$uploadImgUrl"
                :headers="headers"
              >
              </el-upload>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-button">
        <div class="cancel" @click="handleCloseDialog">
          {{ lang === "cn" ? "取 消" : "Cancel" }}
        </div>
        <div class="confirm" @click="verifyForm">
          {{ lang === "cn" ? "确 定" : "Confirm" }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDictionary,
  getBusinessOpportunityList,
  deleteBusinessOpportunity,
  getProductLabelInBusinessOpportunity,
  getBusinessOpportunityDetail,
  modifyBusinessOpportunity,
} from "../api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import { skipOrNextStep } from "@/api/api";
export default {
  components: { top, navMenu },
  name: "opportunity",
  data() {
    return {
      loading: false,
      stepMenuList: [],
      detail: "",
      active: -1,
      lang: "",
      headers: {},
      opportunityNumber: 0,
      keywords: "",
      tableData: [],
      total: 0,
      pageNumber: 1,
      pageSize: 10,
      business_opportunity_options: [],
      audit_status_options: [],
      showDialog: false,
      productLabelList: [],
      opportunityForm: {
        category: "",
      },
      opportunityRules: {
        category: [
          {
            required: true,
            message:
              "请选择商机类别 / Please Select The Business Opportunity Type",
            trigger: "blur",
          },
        ],
        product_category_id: [
          {
            required: true,
            message: "请选择商品标签 / Please Select The Product Label",
            trigger: "blur",
          },
        ],
        requirement: [
          {
            required: true,
            message:
              "请输入需求描述 / Please Enter The Requirement Description",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/opportunity";
    });
    this.detail = stepMenuList[index];
    this.active = index;
    this.lang = localStorage.getItem("language");
    this.headers = {
      token: localStorage.getItem("token"),
    };
    this.getDictionaryData();
  },
  methods: {
    async getDictionaryData() {
      const res = await getDictionary("type=business,audit_sttus");
      if (res.data.code == 1) {
        this.business_opportunity_options = res.data.data.business;
        this.audit_status_options = res.data.data.audit_sttus;
        this.getOpportunityList();
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to fetch the dictionary data!");
        }
      }
    },
    async getOpportunityList() {
      let data = {
        requirement: this.keywords,
        page_no: this.pageNumber,
        page_size: this.pageSize,
      };
      const res = await getBusinessOpportunityList(this.$qs.stringify(data));
      if (res.data.code == 1) {
        res.data.data.lists.forEach((item) => {
          for (let i = 0; i < this.business_opportunity_options.length; i++) {
            if (item.category == this.business_opportunity_options[i].value) {
              if (this.lang === "cn") {
                item.business_opportunity =
                  this.business_opportunity_options[i].name;
              } else {
                item.business_opportunity =
                  this.business_opportunity_options[i].name_en;
              }
              break;
            }
          }
          for (let j = 0; j < this.audit_status_options.length; j++) {
            if (item.examine == this.audit_status_options[j].value) {
              switch (this.audit_status_options[j].value) {
                case "0":
                  item.textColor = "#FAAD14";
                  break;
                case "1":
                  item.textColor = "#52C41A";
                  break;
                case "2":
                  item.textColor = "#FF4D4F";
                  break;
              }
              if (this.lang == "cn") {
                item.audit_status = this.audit_status_options[j].name;
              } else {
                item.audit_status = this.audit_status_options[j].name_en;
              }
              break;
            }
          }
        });
        this.total = Number(res.data.data.count);
        this.opportunityNumber = Number(res.data.data.count);
        this.tableData = res.data.data.lists;
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to get the business opportunity list");
        }
      }
    },
    handleCurrentPageChange(val) {
      this.pageNumber = val;
      this.getOpportunityList();
    },
    handleSearchKeywords() {
      this.pageNumber = 1;
      this.getOpportunityList();
    },
    handleDeleteBusinessOpportunity(data) {
      let obj = {};
      if (this.lang === "cn") {
        obj.content = "请问您是否确认删除?";
        obj.tips = "删除";
        obj.comfirm = "确定";
        obj.cancel = "取消";
      } else {
        obj.content = "Are you sure you want to delete?";
        obj.tips = "Delete";
        obj.comfirm = "Confirm";
        obj.cancel = "Cancel";
      }
      this.$confirm(obj.content, obj.tips, {
        confirmButtonText: obj.comfirm,
        cancelButtonText: obj.cancel,
        type: "warning",
      }).then(async () => {
        const res = await deleteBusinessOpportunity({
          id: data.id,
        });
        if (res.data.code == 1) {
          if (this.lang == "cn") {
            this.$message.success(res.data.msg);
          } else {
            this.$message.success("Successfully Delete");
          }
          this.getOpportunityList();
        } else {
          if (this.lang == "cn") {
            this.$message.error(res.data.msg);
          } else {
            this.$message.error("Failed to Delete");
          }
        }
      });
    },
    handleShowDialog(id) {
      this.getProductLabel(id);
    },
    handleCloseDialog() {
      this.showDialog = false;
      this.opportunityForm = {};
    },
    async getProductLabel(id) {
      const res = await getProductLabelInBusinessOpportunity();
      if (res.data.code == 1) {
        this.productLabelList = res.data.data;
        this.getOpportunityDetail(id);
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to get the product label");
        }
      }
    },
    async getOpportunityDetail(id) {
      const res = await getBusinessOpportunityDetail(id);
      if (res.data.code == 1) {
        res.data.data.category = res.data.data.category + "";
        res.data.data.examine = res.data.data.examine + "";
        res.data.data.product_category_id = Number(
          res.data.data.product_category_id
        );
        this.opportunityForm = res.data.data;
        this.showDialog = true;
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to get the business opportunity detail");
        }
      }
    },
    beformUploadImg(file) {
      this.loading = true;
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        if (this.lang === "cn") {
          this.$message.error("上传图片必须为JPG或PNG格式!");
        } else {
          this.$message.error("Uploaded images must be in JPG or PNG format!");
        }
        this.loading = false;
        return false;
      }
      if (file.size / 1024 / 1024 >= 2) {
        if (this.lang === "cn") {
          this.$message.error("上传图片大小不能超过2M!");
        } else {
          this.$message.error("Uploaded images must be under 2MB in size!");
        }
        this.loading = false;
        return false;
      }
    },
    uploadImgSuccess(res) {
      if (res.code == 1) {
        this.loading = false;
        if (this.lang === "cn") {
          this.$message.success(res.msg);
        } else {
          this.$message.success("Upload successful!");
        }
        if (Array.isArray(this.opportunityForm.imgs)) {
          this.opportunityForm.imgs.push(res.data.uri);
        } else {
          this.opportunityForm.imgs = [res.data.uri];
        }
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.msg);
        } else {
          this.$message.error("Upload failed!");
        }
      }
    },
    deleteImageInForm(index) {
      this.opportunityForm.imgs.splice(index, 1);
    },
    handleProductCategoryChange(val) {
      let result = this.productLabelList.find((item) => item.id == val);
      this.opportunityForm.product_category = result.category_name;
      this.opportunityForm.product_category_en = result.en_category_name;
    },
    verifyForm() {
      let obj = {};
      if (this.lang === "cn") {
        obj.content = "请问您是否确认要提交?";
        obj.tips = "确认提交";
        obj.comfirm = "确定";
        obj.cancel = "取消";
      } else {
        obj.content = "Are you sure you want to submit?";
        obj.tips = "Confirm Submission";
        obj.comfirm = "Confirm";
        obj.cancel = "Cancel";
      }
      this.$confirm(obj.content, obj.tips, {
        confirmButtonText: obj.comfirm,
        cancelButtonText: obj.cancel,
        type: "warning",
      })
        .then(() => {
          let arr = [];
          Object.keys(this.$refs).forEach((item) => {
            arr.push(this.checkForm(item));
          });
          Promise.all(arr)
            .then(() => {
              this.submitForm();
            })
            .catch((error) => {
              this.$message.error(error.trim());
            });
        })
        .catch(() => {});
    },
    checkForm(formName) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate((valid, field) => {
          if (valid) {
            resolve();
          } else {
            let firstFailField = Object.keys(field)[0];
            let firstFailFieldMessage =
              field[firstFailField][0].message.split("/");
            let backMessage = "";
            if (this.lang === "cn") {
              backMessage = firstFailFieldMessage[0];
            } else {
              backMessage =
                firstFailFieldMessage[firstFailFieldMessage.length - 1];
            }
            reject(backMessage);
          }
        });
      });
    },
    async submitForm() {
      const res = await modifyBusinessOpportunity(this.opportunityForm);
      if (res.data.code == 1) {
        if (this.lang === "cn") {
          this.$message.success(res.data.msg);
        } else {
          this.$message.success("Edit successful!");
        }
        this.showDialog = false;
        this.opportunityForm = {};
        this.getOpportunityList();
      } else {
        if (this.lang === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Edit failed");
        }
      }
    },
    toResponseList(data) {
      this.$router.push({
        path: "/response",
        query: {
          id: data.id,
        },
      });
    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        // if (this.detail.action == 1 || this.detail.action == 4) {
        //   this.toPath();
        // } else {
        //   this.$message.warning("请完善信息!");
        // }
        if (this.detail.action >= 2) {
          this.toPath();
        } else if (this.detail.is_verify == 1) {
          this.$message.warning("请完善信息!");
        } else {
          this.toPath();
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action) {
      let data = {
        action,
        mark: this.detail.mark,
      };
      skipOrNextStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(
              this.lang === "cn" ? "操作成功" : "Operation successful"
            );
            this.toPath();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, id } = this.stepMenuList[this.active];
      if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  > p {
    margin: 20px 0 10px;
    color: #333;
    span {
      color: #409eff;
      font-weight: 700;
    }
  }
}
.content-main {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 30px 40px 40px;
  border-radius: 10px;
}
.search-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: end;
  background: #fff;
  // padding: 20px;
  margin: 20px 0;
  border-radius: 10px;
  .search-input {
    width: 30%;
    font-size: 14px;
    color: #7f8fa4;
    line-height: 22px;
    margin-right: 24px;
    p {
      margin-bottom: 7px;
    }
    .search-btn {
      width: 103px;
      height: 38px;
      color: #fff;
      font-size: 14px;
      line-height: 38px;
      text-align: center;
      background: #fc933f;
      border-radius: 3px;
      cursor: pointer;
    }
  }
}
.pagination_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;
  /deep/ .el-pagination {
    width: 100%;
    text-align: right;
  }
  .pagination_left {
    display: flex;
    .pagination_btn {
      color: #fff;
      height: 32px;
      font-size: 14px;
      cursor: pointer;
      line-height: 32px;
      padding: 0 12px;
      border-radius: 4px;
      background: #3d83e9;
      margin-right: 10px;
    }
  }
}
.conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
/deep/ .el-table::before {
  width: 0;
}
/deep/ .el-table {
  .el-image {
    width: 100px;
    height: 100px;
    cursor: pointer;
  }
  .buttonGroup {
    display: flex;
    .responseButton {
      color: #3d83e9;
      cursor: pointer;
      margin-right: 10px;
    }
  }

  .demandDescription {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
/deep/ .el-dialog {
  border-radius: 12px;
  .el-form-item {
    width: 80%;
    .el-select {
      width: 100%;
    }
    .image-wrapper {
      display: flex;
      flex-wrap: wrap;
      .image-box {
        width: 150px;
        height: 150px;
        margin-right: 20px;
        margin-bottom: 20px;
        position: relative;
        .el-image {
          width: 100%;
          height: 100%;
        }
        .image-mask {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.7);
          visibility: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            font-size: 28px;
            color: #409eef;
            cursor: pointer;
          }
        }
      }
      .image-box:hover .image-mask {
        visibility: visible;
      }
      .image-uploader {
        width: 150px;
        height: 150px;
        box-sizing: border-box;
        border: 1px dashed #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        color: #ccc;
        cursor: pointer;
        position: relative;
        > div:last-child {
          width: 150px;
          height: 150px;
          position: absolute;
          top: 0;
          left: 0;
          .el-upload {
            width: 100%;
            height: 100%;
          }
        }
      }
      .image-uploader:hover {
        color: #409eef;
        border-color: #409eef;
      }
    }
  }
  .dialog-button {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 40px;
    margin-right: 20px;
    div {
      width: 72px;
      height: 38px;
      text-align: center;
      line-height: 38px;
      font-size: 14px;
      box-sizing: border-box;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      font-weight: 500;
      cursor: pointer;
    }
    .confirm {
      margin-left: 10px;
      background-color: #409eef;
      color: #fff;
      border: none;
    }
    .confirm:hover {
      opacity: 0.8;
    }
    .cancel:hover {
      color: #409eef;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }
}
</style>